/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const ThermometerSimpleOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 15.75a1.876 1.876 0 1 0 0 3.75 1.876 1.876 0 1 0 0-3.75zm0 0v-7.5m-3 5.53V4.5c0-.8.32-1.56.88-2.12A2.997 2.997 0 0 1 15 4.5v9.28c.8.63 1.39 1.48 1.67 2.46a4.86 4.86 0 0 1-1.84 5.35c-.83.59-1.81.91-2.83.91s-2-.32-2.83-.91a4.85 4.85 0 0 1-1.84-5.35c.28-.98.87-1.83 1.67-2.46z"
})));
// Fill
const ThermometerSimpleFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M15.745 13.43V4.5c0-.99-.4-1.95-1.1-2.65s-1.66-1.1-2.65-1.1-1.95.4-2.65 1.1-1.1 1.66-1.1 2.65v8.93c-.59.53-1.07 1.17-1.39 1.9-.32.72-.49 1.5-.48 2.29 0 1.5.59 2.93 1.64 3.98a5.624 5.624 0 0 0 7.96 0 5.631 5.631 0 0 0 1.65-3.98c0-.79-.17-1.57-.49-2.29-.32-.73-.8-1.37-1.39-1.9zm-3.75-11.18c.6 0 1.17.24 1.59.66s.66.99.66 1.59v3h-4.5v-3c0-.6.24-1.17.66-1.59s.99-.66 1.59-.66z"
})));
// DuoTone
const ThermometerSimpleDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M15 13.78V4.5c0-.8-.32-1.56-.88-2.12A2.997 2.997 0 0 0 9 4.5v9.28c-.8.63-1.39 1.48-1.67 2.46a4.86 4.86 0 0 0 1.84 5.35c.83.59 1.81.91 2.83.91s2-.32 2.83-.91a4.85 4.85 0 0 0 1.84-5.35c-.28-.98-.87-1.83-1.67-2.46zm-3 5.72c-.37 0-.73-.11-1.04-.32-.31-.2-.55-.49-.69-.84-.14-.34-.18-.72-.11-1.08s.25-.7.51-.96a1.915 1.915 0 0 1 2.05-.41c.34.14.63.38.84.69s.31.67.31 1.04c0 .5-.2.98-.55 1.33s-.82.55-1.32.55z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M12 15.75a1.876 1.876 0 1 0 0 3.75 1.876 1.876 0 1 0 0-3.75zm0 0v-7.5m-3 5.53V4.5c0-.8.32-1.56.88-2.12A2.997 2.997 0 0 1 15 4.5v9.28c.8.63 1.39 1.48 1.67 2.46a4.86 4.86 0 0 1-1.84 5.35c-.83.59-1.81.91-2.83.91s-2-.32-2.83-.91a4.85 4.85 0 0 1-1.84-5.35c.28-.98.87-1.83 1.67-2.46z"
})));
/**
  Icon ThermometerSimpleIcon in weather group
*/
export const ThermometerSimpleIcon = createIcon('ThermometerSimpleIcon', 'thermometer-simple', 'weather', ThermometerSimpleOutline, ThermometerSimpleFill, ThermometerSimpleDuotone, "0 0 24 24");